import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PendingCancellationActionData {
    preselectedAction?: 'cancel' | 'complete' | 'waitingRoom';
}

export type PendingCancellationActionResult =
    | { action: 'complete' }
    | { action: 'waitingRoom' }
    | { action: 'cancel' };

@Component({
    selector: 'app-pending-cancellation-action-dialog',
    templateUrl: './pending-cancellation-action-dialog.component.html',
    styleUrls: ['./pending-cancellation-action-dialog.component.scss'],
    standalone: false
})
export class PendingCancellationActionDialogComponent {
    selectedAction: 'cancel' | 'complete' | 'waitingRoom' | null = null;

    constructor(
        public dialogRef: MatDialogRef<PendingCancellationActionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PendingCancellationActionData
    ) {
        if (data?.preselectedAction) {
            this.selectAction(data.preselectedAction);
        }
    }

    selectAction(action: 'cancel' | 'complete' | 'waitingRoom') {
        this.selectedAction = action;
    }

    confirm() {
        if (!this.selectedAction) return;
        this.dialogRef.close({ action: this.selectedAction } as PendingCancellationActionResult);
    }

    close() {
        this.dialogRef.close(null);
    }
}
